// extracted by mini-css-extract-plugin
module.exports = {"header":"header__2uitE","scrolled":"scrolled__1zP4s","active":"active__3taVy"};